<template>
    <el-card class="mini-box-card  box-d-card" >
        <template class="mini-card-header" #header>
            <span>Handover</span>

        </template>
        <el-card class="handover-box" shadow="never" >
            <div class="icon-box warning-bn" v-if="enquiry.bookingdetails.operation_handover=='Sent'">
                <el-icon><QuestionFilled /></el-icon>
            </div>
            <div class="icon-box red-bn" v-else-if="enquiry.bookingdetails.operation_handover=='Rejected'">
                <el-icon><CircleCloseFilled /></el-icon>
            </div>
            <div class="icon-box success-bn" v-else-if="enquiry.bookingdetails.operation_handover=='Accepted'">
                <el-icon><SuccessFilled /></el-icon>
            </div>
            <div class="icon-box" v-else>
                <el-icon><WarningFilled /></el-icon>
            </div>
            <div class="details">
                <h6>Operation Handover</h6>
                <p>{{ enquiry.bookingdetails.operation_handover}}</p>
            </div>
            <div class="actions" v-if="(authuser.department=='Sales' || authuser.is_fullaccess==1) && (enquiry.bookingdetails.operation_handover=='Pending' || enquiry.bookingdetails.operation_handover=='Rejected')">
                <el-button type="primary" size="small" @click="handoveroperation('Sent')">Handover</el-button>
            </div>
            <div class="actions" v-else-if="(authuser.department=='Operation' || authuser.is_fullaccess==1) && (enquiry.bookingdetails.operation_handover=='Sent')">

                <el-button type="success" size="small"  @click="openAcceptDialog">
                    Accept
                </el-button>
                <el-button  type="danger" size="small" class="ml-2"  @click="handoveroperation('Rejected')">
                    Reject
                </el-button>
            </div>
            <div class="actions" v-else-if="authuser.is_fullaccess==1 && enquiry.bookingdetails.operation_handover=='Accepted' && enquiry.bookingdetails.account_handover!='Accepted'">
                <el-button type="primary" size="small" @click="handoveroperation('Rejected')">Cancel</el-button>
            </div>
        </el-card>

        <el-card class="handover-box mt-2" shadow="never" >
            <div class="icon-box warning-bn" v-if="enquiry.bookingdetails.account_handover=='Sent'">
                <el-icon><QuestionFilled /></el-icon>
            </div>
            <div class="icon-box red-bn" v-else-if="enquiry.bookingdetails.account_handover=='Rejected'">
                <el-icon><CircleCloseFilled /></el-icon>
            </div>
            <div class="icon-box success-bn" v-else-if="enquiry.bookingdetails.account_handover=='Accepted'">
                <el-icon><SuccessFilled /></el-icon>
            </div>
            <div class="icon-box" v-else>
                <el-icon><WarningFilled /></el-icon>
            </div>
            <div class="details">
                <h6>Account Handover</h6>
                <p>{{ enquiry.bookingdetails.account_handover}}</p>
            </div>
            <div class="actions" v-if="enquiry.bookingdetails.operation_handover=='Accepted' && authuser.department=='Operation' && (enquiry.bookingdetails.account_handover=='Pending' || enquiry.bookingdetails.account_handover=='Rejected')">
                <el-button type="primary" size="small" @click="handoveraccount('Sent')">Handover</el-button>
            </div>
            <div class="actions" v-else-if="authuser.department=='Account' && (enquiry.bookingdetails.account_handover=='Sent')">

                <el-button type="success" size="small"  @click="handoveraccount('Accepted')">
                    Accept
                </el-button>
                <el-button  type="danger" size="small" class="ml-2"  @click="handoveraccount('Rejected')">
                    Reject
                </el-button>
            </div>
            <div class="actions" v-else-if="authuser.is_fullaccess==1 && enquiry.bookingdetails.account_handover=='Accepted' && enquiry.bookingdetails.final_handover!='Accepted' && enquiry.bookingdetails.final_handover!='Sent'">
                <el-button type="primary" size="small" @click="handoveraccount('Rejected')">Cancel</el-button>
            </div>
        </el-card>

        <el-card class="handover-box mt-2" shadow="never" >
            <div class="icon-box warning-bn" v-if="enquiry.bookingdetails.final_handover=='Sent'">
                <el-icon><QuestionFilled /></el-icon>
            </div>
            <div class="icon-box red-bn" v-else-if="enquiry.bookingdetails.final_handover=='Rejected'">
                <el-icon><CircleCloseFilled /></el-icon>
            </div>
            <div class="icon-box success-bn" v-else-if="enquiry.bookingdetails.final_handover=='Accepted'">
                <el-icon><SuccessFilled /></el-icon>
            </div>
            <div class="icon-box" v-else>
                <el-icon><WarningFilled /></el-icon>
            </div>
            <div class="details">
                <h6>Close File</h6>
                <p>{{ enquiry.bookingdetails.final_handover}}</p>
            </div>
            <div class="actions" v-if="enquiry.bookingdetails.account_handover=='Accepted' && authuser.department=='Account' && (enquiry.bookingdetails.final_handover=='Pending' || enquiry.bookingdetails.final_handover=='Rejected')">
                <el-button type="primary" size="small" @click="closefile('Sent')">Handover</el-button>
            </div>
            <div class="actions" v-else-if="authuser.is_fullaccess==1 && (enquiry.bookingdetails.final_handover=='Sent')">

                <el-button type="success" size="small"  @click="closefile('Accepted')">
                    Accept
                </el-button>
                <el-button  type="danger" size="small" class="ml-2"  @click="closefile('Rejected')">
                    Reject
                </el-button>
            </div>
            <div class="actions" v-else-if="authuser.is_fullaccess==1 && enquiry.bookingdetails.final_handover=='Accepted'">
                <el-button type="primary" size="small" @click="closefile('Rejected')">Cancel</el-button>
            </div>
        </el-card>

        <el-card class="handover-box mt-2" shadow="never" >

            <div class="icon-box success-bn" v-if="enquiry.bookingdetails.customer_handover==1">
                <el-icon><SuccessFilled /></el-icon>
            </div>
            <div class="icon-box" v-else>
                <el-icon><WarningFilled /></el-icon>
            </div>
            <div class="details">
                <h6>Customer Handover</h6>
                <p>{{ enquiry.bookingdetails.customer_handover==1?'Sent':'Pending'}}</p>
            </div>
            <div class="actions" v-if="enquiry.permissions.customerhandover==true ">
                <el-button type="primary" size="small" @click="handtocust()">Handover</el-button>
            </div>

        </el-card>



    </el-card>

    <el-dialog v-model="dialogAcceptHandover" title="Accept Operation Handover" width="480px">
        <p class="mb-2 text-muted">Choose the checklist template for this trip.</p>
        <el-form label-position="top" v-loading="templatesLoading">
            <el-form-item label="Checklist template" required>
                <el-select v-model="selectedTemplateId" placeholder="Select template" style="width: 100%" filterable>
                    <el-option
                        v-for="tpl in templateOptions"
                        :key="tpl.id"
                        :label="tpl.name + (tpl.is_default ? ' (Default)' : '')"
                        :value="tpl.id"
                    />
                </el-select>
            </el-form-item>
            <el-form-item label="Note (optional)">
                <el-input v-model="acceptMessage" type="textarea" :rows="2" />
            </el-form-item>
        </el-form>
        <template #footer>
            <el-button @click="dialogAcceptHandover=false">Cancel</el-button>
            <el-button type="success" :loading="loading" :disabled="!selectedTemplateId" @click="confirmAcceptHandover">
                Accept &amp; create checklist
            </el-button>
        </template>
    </el-dialog>

    <el-drawer size="70%" v-model="dialogCustomerHandover" direction="rtl">
        <template #header>
            <h4>Handover to Customer</h4>
        </template>
        <template #default>
            <el-form
                ref="aasthndruleFormRef"
                :model="customerhandover"
                status-icon
                :rules="customerhandoverrules"
                label-width="auto"
                class="demo-ruleForm"
                label-position="top"

            >



                <el-form-item label="Mail" prop="data">
                    <textarea class="form-control "  v-model="customerhandover.data"  :rows="10"></textarea>

                </el-form-item>

                <el-form-item label="Attachments" prop="files">

                    <el-row >
                        <el-col v-for="(gattachment,index) in enquiry.groupattachments">
                            <el-col v-if="index=='Flight Tickets' || index=='Vouchers' || index=='Insurance' || index=='Bus Tickets' || index=='Train Tickets' || index=='Visa'">
                                <p class="mb-0"><b>{{index}}</b></p>
                                <el-col v-for="attachment in gattachment">
                                    <input type="checkbox"  v-model="customerhandover.files" :value="attachment.id"/>
                                    <el-tag type="primary" class="ml-2" @click="viewfile(attachment.link)">{{attachment.filename}}</el-tag>
                                </el-col>
                            </el-col>

                        </el-col>
                    </el-row>
                </el-form-item>

            </el-form>
        </template>
        <template #footer>
            <div style="flex: auto">
                <el-button type="primary" @click="dialogCustomerHandover=false">Cancel</el-button>
                <el-button type="primary" @click="custhandsubmitForm()" :loading="cloading" :disabled="cloading">Handover</el-button>
            </div>
        </template>
    </el-drawer>
</template>

<script>


import {
    ElCheckboxGroup,ElIcon,ElAvatar,ElCard,ElTag,ElRow,ElCol,ElButton,ElDialog,ElForm,ElFormItem,ElInput,ElSelect,ElOption,ElDrawer,ElCheckbox
} from 'element-plus'
import { Edit,WarningFilled,QuestionFilled,CircleCloseFilled,SuccessFilled } from '@element-plus/icons-vue'
import $ from "jquery";

export default {
    name: "EnquiryHandover",
    props: {
        enquiry: {
            type: Object,
            default() {
                return null
            }
        },
        authuser: {
            type: Object,
            default() {
                return null
            }
        }
    },
    emits: ["saved"],
    components: { ElCheckboxGroup,ElDrawer,ElCheckbox,ElIcon,WarningFilled,QuestionFilled,CircleCloseFilled,SuccessFilled,ElAvatar,ElSelect,ElOption,ElCard,ElTag,ElRow,ElCol,ElButton,Edit,ElDialog,ElForm,ElFormItem,ElInput },
    data() {
        return {
            dialogCustomerHandover:false,
            dialogAcceptHandover:false,
            templatesLoading:false,
            templateOptions:[],
            selectedTemplateId:null,
            acceptMessage:'',
            cloading:false,
            loading:false,
            edit:false,
            states:[],
            cities:[],
            form:{
                assigned_to:'',

            },
            rules:{
                assigned_to: [
                    {
                        required: true, message: 'Select Agent',
                        trigger: ['blur','change'],
                    }
                ],

            },
            setting:{
                ajax: {
                    url: '/myusers',
                    dataType: 'json',
                    delay: 250,
                    processResults: function (data) {
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.name,
                                    id: item.id
                                }
                            })
                        };
                    },
                    cache: true
                }
            },
            customerhandover:{
                data : '',
                files:[]
            },
            customerhandoverrules:{
                data: [
                    {
                        required: true, message: 'Select Agent',
                        trigger: ['blur','change'],
                    }
                ],
            }

        }
    },
    created(){

    },
    methods:{
        viewfile(link){
            window.open(link, "_blank", "width="+screen.availWidth+",height="+screen.availHeight)

        },
        editdet(){
            this.form.assigned_to='';



        },
        submitForm(){
            const formEl=this.$refs.ruleFormRef;
            if (!formEl) return
            formEl.validate((valid) => {
                if (valid) {
                    this.save()
                } else {
                    return false
                }
            })


        },
        save(){
            let currentObj = this;
            currentObj.loading=true;
            axios.post('/saveenquirydetails?id='+this.enquiry.id,this.form).then(function (response) {


                toastr.success('Enquiry Assigned Succesfully.');
                currentObj.$emit("saved");
                currentObj.loading=false;
                currentObj.edit=false;
            })
                .catch(function (error) {
                    currentObj.loading=false;
                    toastr.error('Something Wrong try again.');
                });

        },
        handtocust(){
            this.customerhandover.data=this.enquiry.data.customerhandovermail;
            this.dialogCustomerHandover=true;
        },
        custhandsubmitForm(){
            let currentObj = this;
            if(this.customerhandover.files.length>0){
                currentObj.cloading=true;
                axios.post('/enquiry/customerhandover', {'id':this.enquiry.id,'data':this.customerhandover}).then(function (response) {
                    toastr.success('Handovered to Customer Sucessfully');
                    currentObj.cloading=false;
                    currentObj.dialogCustomerHandover=false;
                    currentObj.$emit("saved");

                })
                    .catch(function (error) {
                        currentObj.cloading=false;
                    });
            }
            else{
                toastr.error('Select Attachments');
            }
        },
        applyHandoverStatus(field, status){
            if (this.enquiry && this.enquiry.bookingdetails) {
                this.enquiry.bookingdetails[field] = status;
            }
        },
        async openAcceptDialog(){
            this.acceptMessage = '';
            this.dialogAcceptHandover = true;
            this.templatesLoading = true;
            try {
                const { data } = await axios.get('/operations/template-options');
                this.templateOptions = data.data || [];
                this.selectedTemplateId = data.default_id || (this.templateOptions[0] && this.templateOptions[0].id) || null;
                if (!this.templateOptions.length) {
                    toastr.error('No active checklist templates. Create one under Operations → Templates.');
                }
            } catch (e) {
                this.templateOptions = [];
                this.selectedTemplateId = null;
                toastr.error('Could not load checklist templates.');
            } finally {
                this.templatesLoading = false;
            }
        },
        confirmAcceptHandover(){
            if (!this.selectedTemplateId) {
                toastr.error('Select a checklist template');
                return;
            }
            this.submitOperationHandover('Accepted', this.acceptMessage, this.selectedTemplateId);
        },
        handoveroperation(status){

            if((status=="Sent" && this.enquiry.pricedetaillogs.length>0) || status!="Sent"){
                let currentObj = this;
                Swal.fire({
                    title: 'Are you sure?',
                    input: 'text',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Submit it!'
                }).then((result) => {
                    if (result.isConfirmed) {
                        currentObj.submitOperationHandover(status, result.value, null);
                    }
                });
            }
            else{
                toastr.error('Update Pricing Details');
            }


        },
        submitOperationHandover(status, message, templateId){
            let currentObj = this;
            currentObj.loading=true;
            const payload = {
                id: currentObj.enquiry.id,
                status: status,
                message: message || '',
            };
            if (templateId) {
                payload.template_id = templateId;
            }
            axios.post('/enquiry/operationhandover', payload).then(function () {
                toastr.success('Submitted Sucessfully');
                currentObj.loading=false;
                currentObj.dialogAcceptHandover=false;
                currentObj.applyHandoverStatus('operation_handover', status);
                currentObj.$emit("saved");
            })
                .catch(function () {
                    currentObj.loading=false;
                    toastr.error('Something Wrong try again.');
                });
        },
        handoveraccount(status){

            if((status=="Sent" && this.enquiry.pricedetaillogs.length>0) || status!="Sent"){
                let currentObj = this;
                Swal.fire({
                    title: 'Are you sure?',
                    input: 'text',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Submit it!'
                }).then((result) => {
                    if (result.isConfirmed) {

                        currentObj.loading=true;
                        axios.post('/enquiry/accounthandover', {'id':currentObj.enquiry.id,'status':status,'message':result.value}).then(function (response) {
                            toastr.success('Submitted Sucessfully');
                            currentObj.loading=false;
                            currentObj.applyHandoverStatus('account_handover', status);
                            currentObj.$emit("saved");

                        })
                            .catch(function (error) {
                                currentObj.loading=false;
                                toastr.error('Something Wrong try again.');
                            });
                    }
                });
            }
            else{
                toastr.error('Update Pricing Details');
            }
        },
        closefile(status){
            if((status=="Sent" && this.enquiry.pricedetaillogs.length>0) || status!="Sent"){
                let currentObj = this;
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Submit it!'
                }).then((result) => {
                    if (result.isConfirmed) {

                        currentObj.loading=true;
                        axios.post('/enquiry/closefile', {'id':currentObj.enquiry.id,'status':status}).then(function (response) {
                            toastr.success('Submitted Sucessfully');
                            currentObj.loading=false;
                            currentObj.applyHandoverStatus('final_handover', status);
                            currentObj.$emit("saved");

                        })
                            .catch(function (error) {
                                currentObj.loading=false;
                                toastr.error('Something Wrong try again.');
                            });
                    }
                });
            }
            else{
                toastr.error('Update Pricing Details');
            }
        },


    }
}
</script>

<style scoped>

</style>
